<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive" :can-cancel="true">
      <div class="card" style="border-radius: 5px;" v-if="isCardModalActive">
        <header class="card-header">
          <div class="card-header-title edit-title-wrapper">
            <span class="edit-title">スケジュール編集</span>
          </div>
        </header>
        <div class="card-content scroll-box">
          <!-- カレンダー連携 -->
          <div class="message" v-if="!info.startEditable">
            <div class="tab-box-form">
              <div class="tab-box-left">
                <p style="text-align: left;">
                  <b>タイトル</b>
                </p>
              </div>
              <div class="tab-box-right">
                {{info.title}}
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-form">
              <div class="tab-box-left">
                <p style="text-align: left;">
                  <b>日時</b>
                </p>
              </div>
              <div class="tab-box-right">
                {{new Date(info.start).toLocaleString()}} - {{new Date(info.end).toLocaleString()}}
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-form">
              <div class="tab-box-left">
                <p style="text-align: left;">
                  <b>メモ</b>
                </p>
              </div>
              <div class="tab-box-right">
                <p style="white-space: pre-wrap; text-align: left;"><span v-html="$sanitize(info.description)"></span></p>
              </div>
            </div>
            <div class="dot-line"></div>
            <div class="tab-box-form">
              <div class="tab-box-left">
                <p style="text-align: left;">
                  <b>添付ファイル</b>
                </p>
              </div>
              <div class="tab-box-right">
                <template v-if="isAttachments()">
                  <ul class="file-names">
                    <li v-for="(attachment, i) in getAttachments()" :key="i">
                      <a :href="attachment.file"
                        target=”_blank”
                        style="white-space: pre-wrap; text-align: left;">{{attachment.filename}}</a>
                    </li>
                  </ul>
                </template>
                <template v-else>
                  <p style="white-space: pre-wrap; text-align: left;">なし</p>
                </template>
              </div>
            </div>
          </div>
          <div class="message" v-if="info.startEditable">
            <div class="tab-box">
              <div class="tab-box-form">
                <div class="tab-box-left">
                  <p style="text-align: left;">
                    <b>タイトル</b>
                  </p>
                </div>
                <div class="tab-box-right">
                  <b-input style="width: 100%;" placeholder="タイトルを入力" v-model="info.title" max-length="100"></b-input>
                </div>
              </div>
              <div class="dot-line"></div>
              <div class="tab-box-form">
                <div class="tab-box-left">
                  <p style="text-align: left;">
                    <b>日時</b>
                  </p>
                </div>
                <div class="tab-box-right">
                  <b-datetimepicker
                      rounded
                      v-model="info.start"
                      placeholder="開始日時"
                      icon="calendar-today"
                      horizontal-time-picker>
                  </b-datetimepicker>
                  <p style="display: flex; justify-content: center; align-items: center; margin: 0 8px;"> ～ </p>
                  <b-datetimepicker
                      rounded
                      v-model="info.end"
                      placeholder="終了日時"
                      icon="calendar-today"
                      horizontal-time-picker>
                  </b-datetimepicker>
                </div>
              </div>
              <div class="dot-line"></div>
              <div class="tab-box-form">
                <div class="tab-box-left" style="flex-wrap: wrap;">
                  <p><b>メモ</b></p>
                  <br>
                  <span style="text-align: left; color: #666; font-size: 12px;">日程調整をした日の予定に入れるメモ欄です。</span>
                </div>
                <div class="tab-box-right">
                  <textarea class="input textarea" v-model="info.description" maxlength="200"></textarea>
                </div>
              </div>
              <div class="dot-line"></div>
              <div class="tab-box-form">
                <div class="tab-box-left">
                  <p style="text-align: left;">
                    <b>添付ファイル</b>
                  </p>
                </div>
                <div class="tab-box-right">
                  <template v-if="isAttachments()">
                    <ul class="file-names">
                      <li v-for="(attachment, i) in getAttachments()" :key="i">
                        <a :href="attachment.file"
                          target=”_blank”
                          style="white-space: pre-wrap; text-align: left;">{{attachment.filename}}</a>
                      </li>
                    </ul>
                  </template>
                  <template v-else>
                    <p style="white-space: pre-wrap; text-align: left;">なし</p>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-bottom: 8px;" v-if="isLineWorksRecurrence()">
            ※ 繰り返し予定として登録されているため<br />
            <span style="padding-left: 1.1em;">HRモンスターからの変更および削除を行うことができません。</span>
          </div>
          <div style="margin-bottom: 8px;" v-if="isLineWorksInvitation()">
            ※ 招待予定として登録されているため変更を行うことができません。
          </div>
          <template v-if="info.startEditable">
            <b-field style="width: 100%">
              <div style="width: 48%; align: left">
                <button class="button is-primary is-fullwidth" @click="closeEditPage();">
                  キャンセル
                </button>
              </div>
              <div style="width: 5%;">
              </div>
              <div style="width: 48%; align: right">
                <button class="button is-primary is-fullwidth" @click="clickSaveEvent(); closeEditPage();" :disabled="isLineWorksRecurrence() || isLineWorksInvitation()">
                  変更
                </button>
              </div>
              <div style="width: 5%;">
              </div>
              <div style="width: 48%; align: right">
                <button class="button is-primary is-fullwidth" @click="clickDeleteEvent()" :disabled="isLineWorksRecurrence()">
                  削除
                </button>
              </div>
            </b-field>
          </template>
          <template v-else>
            <b-field style="width: 100%">
              <div style="width: 100%; align: left">
                <button class="button is-primary is-fullwidth" @click="closeEditPage();">
                  閉じる
                </button>
              </div>
            </b-field>
          </template>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ModalEditEvent',
  computed: {
    ...mapState('calendar', ['eventGroup']),
  },
  data () {
    return {
      info: null,
      isCardModalActive: false,
    }
  },
  methods: {
    tempEventFile () {
      let ret = []
      for (const e of this.eventGroup) {
        if (e.calendar_id === this.info.id) {
          ret.push(e.event_file_ref)
        }
      }
      return ret
    },
    isAttachments () {
      // 現状attachmentsはGoogleカレンダーでのみ値が入ってくる
      // Garoon、CybozuOfficeについてはAPIが提供されていないのでattachments要素が含まれない
      if (this.info.attachments) {
        return true
      } else if (this.tempEventFile().length > 0) {
        return true
      }
      return false
    },
    getAttachments () {
      // 現状attachmentsはGoogleカレンダーでのみ値が入ってくる
      // Garoon、CybozuOfficeについてはAPIが提供されていないのでattachments要素が含まれない
      let attachments = []
      if (this.info.attachments) {
        for (const attachment of this.info.attachments)
        attachments.push(
          {
            file: attachment.fileUrl,
            filename: attachment.title
          }
        )
      } else if (this.tempEventFile().length > 0) {
        for (const attachment of this.tempEventFile())
        attachments.push(
          {
            file: attachment.file,
            filename: attachment.filename
          }
        )
      }
      return attachments
    },
    clickSaveEvent () {
      this.info.type = "update"
      this.$store.dispatch('calendar/updateSchedules', this.info
      ).then(() => {
        if (this.info.calendarType == 'google') {
          this.$store.dispatch('calendar/updateEventScenarios', this.info)
        }
      })
    },
    clickDeleteEvent () {
      if (confirm('予定を削除します。\nよろしいですか？')) {
        this.info.type = "delete"
        this.$store.dispatch('calendar/updateSchedules', this.info
        ).then(() => {
          if (this.info.calendarType == 'google') {
            this.$store.dispatch('calendar/deleteEventScenarios', this.info.id)
          }
        })
        this.closeEditPage()
      }
    },
    closeEditPage () {
      this.isCardModalActive = false
    },
    isLineWorksRecurrence() {
      return this.info.calendarType == 'lineworks' && ('recurrence' in this.info.eventJson || 'recurringEventId' in this.info.eventJson)
    },
    isLineWorksInvitation() {
      return this.info.calendarType == 'lineworks' && this.info.invitation
    }
  }
}
</script>

<style lang='scss' scoped>
.card-header {
  display: flex;
}
.edit-title-wrapper {
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.edit-title {
  font-size: 22px;
  font-weight: 700;
}
.img-icon {
  display:    block;
  min-width:  200px;
  min-height: 200px;
  width:      200px;
  height:     200px;
  max-width:  200px;
  max-height: 200px;
  object-fit: cover;
  border-radius: 50%;
  border: solid thin #ccc;
}
.img-icon-sq {
  display:    block;
  min-width:  300px;
  min-height: 250px;
  width:      300px;
  height:     250px;
  max-width:  300px;
  max-height: 250px;
  border-radius: 5px;
  object-fit: cover;
  border: solid thin #ccc;
}
.btn-default-color{
  background: #f8f8f8;
}
.on_switch {
  background: #EE2C98;
  color: #ffffff;
}
.message {
  background: white;
  height: 500px;
}
.message::-webkit-scrollbar {
    width: 10px;
    height: 0px;
    visibility: hidden;
}
.tab-box {
  background: white;
  border: solid thin #ccc;
  border-radius: 8px;
  height: 400px;
  overflow-y: scroll;
  padding: 16px;
}
.tab-box::-webkit-scrollbar {
    width: 10px;
    height: 0px;
    visibility: hidden;
}
.tab-box-form {
  width: 100%; display: flex; padding: 8px;
}
.tab-box-left {
  width: 30%; display: flex; justify-content: flex-start; align-items: center;
}
.tab-box-right {
  width: 70%; font-size: 13px; padding: 10px; justify-content: flex-start; display: flex;
}
.dot-line {
  height: 10px;
  width: 100%;
  background-image: url('../../../assets/lp/dot.png');
  background-repeat: repeat-x;
  background-size: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
/* Image Upload UI */
.upload-form {
  position: relative;
}
.upload-style {
  width: 100px;
  border-radius: 10px;
  text-decoration: none;
}
.upload-style > input {
  display: none;
}
.button-img {
  width: 300px;
  text-decoration: none !important;
}
.select_container {
  height: 272px;
  overflow: auto;
  border: 1px solid #dbdbdb;
  margin-bottom: 6px;
  border-radius: 3px;
}
.select_container::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.description {
  font-size: 14px;
}
.select_list {
  margin: 16px 0 16px 32px;
  display: flex;
  align-items: center;
}
.patern_num {
  font-size: 14px;
  font-weight: bold;
  margin-right: 16px;
}
.ConnectingWord {
  font-size: 14px;
  margin: 6px;
}
.input_point {
  width: 64px;
}
.if_select {
  margin: 16px;
}
.close-wrapper {
  cursor: pointer;
  font-weight: bold;
  opacity: 0.6;
  margin-left: 16px;
  &:hover {
    opacity: 1;
    color: red;
  }
  .mdi-close {
    &:before {
      font-weight: bold;
    }
  }
}
.checkbox-item-container {
  font-size: 14px;
  padding:10px;
  padding-left:20px;
  &.-wrapper {
    align-items: center;
  }
}
.checkbox-index {
  margin-right: 8px;
}

/* ポイント入力の際勝手に動くバグがあるため、手動入力に変更 */
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number'] {
  -moz-appearance:textfield;
}
input::-ms-clear {
  visibility:hidden
}

.quote-list {
  height: 240px;
  position: absolute;
  right: 8px;
  top: 64px;
  width: 560px;
  border-radius: 5px;
  text-align: left;
  background-color: #ffffff;
  box-shadow: 0 0 3px grey;
  z-index: 10;
  overflow: auto;
  .list-title {
    font-weight: bold;
    margin-bottom: 8px;
  }
}
.quote-list-wrapper {
  overflow-y: scroll;
  margin: 8px;
}
.quote-list-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;

}
.open-quote-btn-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.open-quote-btn {
  cursor: pointer;
}
.quote-list-content {
  table {
    margin: auto;
    font-size: 12px;
  }
  table th {
    padding: 4px;
  }
  table td {
    padding: 4px;
  }
}
.table-container {
  overflow-y: scroll;
}
.table-container::-webkit-scrollbar {
  width: 10px;
  height: 0px;
  visibility: hidden;
}
table thead th {
  top: 0;
  z-index: 1;
  background: #ffffff;
  border: 1px solid #000000;
}
.not-find-quote {
  font-size: 12px;
}
.quote-explain {
  font-size: 12px;
  margin-bottom: 16px;
}
.close-btn {
  cursor: pointer;
}
.file-names {
  li {
    padding: 4px;
  }
  li:hover {
    background-color: #dcdcdc;
  }
  li + li {
    margin-top: 4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/organisms/ModalEditEvent.vue